import { ResponseWrapper } from '@/api/types/base.types'
import { AxiosResponse } from 'axios'

const isBinaryResponseData = (data: unknown): boolean =>
  data instanceof ArrayBuffer || data instanceof Blob

export const isError = (
  response: AxiosResponse<ResponseWrapper<any>, any>,
): boolean => {
  if (!response?.status || response.status < 200 || response.status >= 300) {
    return true
  }

  if (isBinaryResponseData(response.data)) {
    return false
  }

  return response?.data?.status !== 'success'
}
